// 수행평가
import Resource from './Resource'
import axios from 'axios'
export default class Reply extends Resource {
  static ENDPOINT = '/api/article/reply'

  constructor (args) {
    super()
    this.extend(args)
  }

  async save () {
    let res = null;
    if (this._id) {
      this.updateDate = new Date()
      res = await axios.put(`${Reply.ENDPOINT}/${this._id}`, this);
    } else {
      res = await axios.post(`${Reply.ENDPOINT}/${this.commentId}`, this);
    }
    return res.data && new Reply(res.data);
  }

  static create (commentId, writer, content) {
    return new Reply({ commentId, writer, content })
  }
}
